import { computed, MaybeRef, unref } from 'vue';

import { ShowingStatus } from '../interfaces/showing-status.enum';
import { useShowingsQuery } from '../queries/showings.query';
import { groupShowingByDateAndSort } from '../utils/group-showing-by-date.util';
import { getPendingShowings } from '../utils/pending-showings.util';

export function usePropertyShowings(propertyIdRef: MaybeRef<string>) {
  const { data, ...rest } = useShowingsQuery();

  const showings = computed(() => (data.value || [])?.filter(({ property }) => unref(propertyIdRef) === property.id));
  const pendingShowings = computed(() => getPendingShowings(showings.value));
  const upcomingShowings = computed(() => showings.value.filter(({ status }) => status === ShowingStatus.CONFIRMED));
  const groupedByDateUpcomingShowings = computed(() => groupShowingByDateAndSort(upcomingShowings.value));

  return {
    ...rest,
    data,
    showings,
    pendingShowings,
    groupedByDateUpcomingShowings,
  };
}
